import WithSidebar from 'Layout/WithSidebar';
import Banner from 'components/Banner';
import banerImage from 'images/detailed-trial-results-banner.jpg';
import ProductSidebar from 'components/ProductSidebar';
import { data } from 'components/ProductSidebar/mockData';
import PDFBox from 'components/PDFBox';
import { files } from './mockData';

const DetailedTrialResults = () => {
    const slisedData = [...data].slice(5);

    return (
        <div className="container">
            <Banner title="Spring wheat" image={banerImage} buttonText="View results" />
            <div className="inner-container section-padding-y">
                <WithSidebar
                    mobileReversed
                    Sidebar={<ProductSidebar title="Trial results for other crops" data={slisedData} />}
                >
                    <PDFBox data={files} />
                </WithSidebar>
            </div>
        </div>
    );
};

export default DetailedTrialResults;
